<template>
  <!-- <section
      :class="colourClass(backgroundColourObj)"
      class="generic-hero push-v--desktop--large push-v--tablet--large push-v--mobile--large"
  >
    <div class="generic-hero__content">
      <div class="container">
        <div class="generic-hero__lockup">
          <div class="row">
            <div class="col-md-9 col-lg-5 offset-lg-1">
              <span v-if="label" class="generic-hero__label">{{ label }}</span>
              <h1
                  v-if="title"
                  class="generic-hero__animation--1 generic-hero__title h2 push-v--desktop--small push-v--tablet--x-small push-v--mobile--x-small"
              >
                {{ title }}
              </h1>
            </div>
            <div class="generic-hero__animation--2 col-md-9 col-lg-6 offset-lg-1">
              <strong
                  v-if="firstHeaderTitle"
                  class="generic-hero__subtitle-bold push-v--desktop--x-small push-v--tablet--x-small"
              >{{ firstHeaderTitle }}</strong>
              <span
                  v-if="firstHeaderSubtitle"
                  class="generic-hero__subtitle push-v--desktop--x-small push-v--tablet--x-small push-v--mobile--x-small"
              >{{ firstHeaderSubtitle }}</span>
              <WigglyLine
                  v-if="firstHeaderSubtitle"
                  class="generic-hero__wiggly-line push-v--desktop--x-small push-v--tablet--x-small push-v--mobile--x-small"
              />
              <strong
                  v-if="secondHeaderTitle"
                  class="generic-hero__subtitle-bold push-v--desktop--x-small push-v--tablet--x-small"
              >{{ secondHeaderTitle }}</strong>
              <span v-if="secondHeaderSubtitle" class="generic-hero__subtitle generic-hero__subtitle--alt">{{
                secondHeaderSubtitle
              }}</span>
              <div v-if="body" class="generic-hero__body" v-html="body" />
              <call-to-action-button v-if="callToActionLinkText" :call-to-action-link-text="callToActionLinkText" :call-to-action-link="callToActionLink" button-class="generic-hero__cta" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="generic-hero__wave" />
    <figure class="generic-hero__shape">
      <KenticoResponsiveImage :src="image.url" :alt="image.description" class="generic-hero__image" :sizes="imageSizes" />
      <ShapeGenericHero />
    </figure>
    <div :class="colourClass(imageBackgroundShapeColorObj)" class="generic-hero__background-shape" />
  </section>-->

  <section
      id="generic_hero"
      class="generic-hero push-v--desktop--small push-v--tablet--small push-v--mobile--small"
  >
    <div class="generic-hero__content">
      <div class="left-bg bg--primary-midnight">
        <div ref="textBox" class="content__wrapper">
          <div class="content__parent">
            <div class="generic-hero__title">
              <!-- <h1 class="generic-hero__title-image"> -->
              <!-- <Collective /> -->
              <span class="visually-hidden">{{ firstHeaderSubtitle }}</span>
              <!-- </h1> -->

              <p
                  class="generic-hero__slogan text-right--desktop"
              >
                {{ label || firstHeaderTitle || firstHeaderSubtitle }}
              </p>
              <h1 class="generic-hero__title--main">{{ title }}</h1>
              <!-- <p class="generic-hero__subtitle">{{ bodyText }}</p> -->
              <p v-if="body" class="generic-hero__subtitle body-rich-text" v-html="body" />
            </div>
          </div>
          <div class="generic-hero__buttons--wrapper">
            <call-to-action-button
                v-if="callToActionLinkText"
                :call-to-action-link-text="callToActionLinkText"
                :call-to-action-link="callToActionLink"
                button-class="generic-hero__cta generic-hero__button"
                :external-link="externalLink"
            />
          </div>
        </div>
        <div ref="arrowBoxLocation" class="left-bg--arrow-parent" @click="scrollBelow">
          <ArrowIcon class="left-bg--arrow-icon" />
        </div>
      </div>
      <div class="right-bg bg--white">
        <div id="generic-hero-image" ref="genricHeroImage" class="right-bg__image">
          <KenticoResponsiveImage
              :src="image.url"
              :alt="image.description"
              class="generic-hero__image"
              :sizes="imageSizes"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { forceObject } from '~/utils/processor';
import getStatic from '~/utils/get-static';
// import WigglyLine from '~/assets/icons/line.svg?inline';
// import ShapeGenericHero from '~/components/elements/ShapeGenericHero.vue';
import ArrowIcon from '~/assets/icons/new/arrow-down.svg?inline';
import CallToActionButton from '~/components/components/CallToActionButton';
import { BREAKPOINTS, BREAKPOINT_MD, BREAKPOINT_SM, BREAKPOINT_LG, BREAKPOINT_XL, BREAKPOINT_XXL } from '~/utils/constants';
import { gsap, TimelineLite, CSSPlugin, Power1 as Sine } from 'gsap';

export default {
  components: {
    CallToActionButton,
    ArrowIcon,
  },
  props: {
    image: {
      type: Object,
      default() {
        return {
          url: getStatic('/images/content/location/hero.jpg'),
          description: 'Alt tag',
        };
      },
      required: true,
    },
    backgroundColour: {
      type: Array,
      default() {
        return [
          {
            name: 'Pale Yellow',
          },
        ];
      },
    },
    imageBackgroundShapeColor: {
      type: Array,
      default() {
        return [
          {
            name: 'Yellow',
          },
        ];
      },
    },
    label: { type: String, default: '' },
    title: { type: String, default: 'Page name', required: true },
    firstHeaderTitle: { type: String, default: '' },
    firstHeaderSubtitle: { type: String, default: '' },
    secondHeaderTitle: { type: String, default: '' },
    secondHeaderSubtitle: { type: String, default: '' },
    externalLink: { type: String, default: '' },
    body: {
      type: String,
      default:
        '<p></p>',
      required: true,
    },
    callToActionLinkTextTour: { type: String, default: 'Book a Tour' },
    callToActionLinkText: { type: String, default: '' },
    callToActionLink: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      imageSizes: {
        default: [900, 750],
        sizes: [
          { breakpoint: BREAKPOINTS[BREAKPOINT_SM], width: 900, height: 750 },
          { breakpoint: BREAKPOINTS[BREAKPOINT_MD], width: 900, height: 750 },
          { breakpoint: BREAKPOINTS[BREAKPOINT_LG], width: 900, height: 750 },
          { breakpoint: BREAKPOINTS[BREAKPOINT_XL], width: 1200, height: 1000 },
          { breakpoint: BREAKPOINTS[BREAKPOINT_XXL], width: 1200, height: 1000 },
        ],
      },
    };
  },
  computed: {
    backgroundColourObj() {
      return forceObject(this.backgroundColour);
    },
    imageBackgroundShapeColorObj() {
      return forceObject(this.imageBackgroundShapeColor);
    },
    addSeperator() {
      if (
        (this.firstHeaderTitle && this.firstHeaderSubtitle && this.secondHeaderTitle && this.secondHeaderSubtitle) ||
        (this.firstHeaderTitle && this.secondHeaderTitle)
      ) {
        return true;
      }

      return false;
    },
  },
  mounted() {
    this.animate();
  },
  methods: {
    stringToClass(string) {
      return string.toLowerCase().replace(' ', '-');
    },    
    scrollBelow() {
      window.scrollBy({
        top: window.innerHeight,
        left: 0,
        behavior: 'smooth',
      });
    },
    animate() {
      const { textBox, arrowBoxLocation, genricHeroImage } = this.$refs;
      // const plugins = [CSSPlugin];
      gsap.registerPlugin(CSSPlugin);

      const tl = new TimelineLite();
      tl
          .fromTo(genricHeroImage, { autoAlpha: 0.3, x: 150 }, { autoAlpha: 1, x: 0, duration: 1, ease: Sine.easeOut })
          .fromTo(textBox, { autoAlpha: 0, y: 150 }, { autoAlpha: 1, y: 0, duration: 0.7, ease: Sine.easeOut }, '-=0.4')
          .fromTo(arrowBoxLocation, { y: -100, autoAlpha: 0.8 }, { y: 0, autoAlpha: 1, repeat: 4, yoyo: true, duration: 1, ease: Sine.easeIn }, '-=0.4');
    
    },
    colourClass(colorObj) {
      if (colorObj && colorObj.name) {
        const { name } = colorObj;
        return `bg--${this.stringToClass(name)}`;
      }

      return false;
    },
  },
};
</script>

<style lang="scss">
@import '~/assets/scss/atomic/modules/_location_hero_new.scss';
</style>
